export default __webpack_public_path__ + "static/simple-bar-04100332297d6ab7172a66ed406cf745.png";